import * as types from '../types/storeTypes';

const initialState = {
  stores: [],
  stats: null,
  groups: [],
  loading: false,
  error: null,
};

const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_STORES_REQUEST:
    case types.FETCH_STORE_STATS_REQUEST:
    case types.FETCH_STORE_GROUPS_REQUEST:
    case types.CREATE_STORE_GROUP_REQUEST:
    case types.CREATE_STORE_REQUEST:
    case types.UPDATE_STORE_REQUEST:
    case types.DELETE_STORE_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_STORES_SUCCESS:
      return { ...state, loading: false, stores: action.payload };

    case types.FETCH_STORE_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };

    case types.FETCH_STORE_GROUPS_SUCCESS:
      return { ...state, loading: false, groups: action.payload };

    case types.CREATE_STORE_GROUP_SUCCESS:
      return { ...state, loading: false, groups: [...state.groups, action.payload] };

    case types.CREATE_STORE_SUCCESS:
      return { ...state, loading: false, stores: [...state.stores, action.payload] };

    case types.UPDATE_STORE_SUCCESS:
      return {
        ...state,
        loading: false,
        stores: state.stores.map((s) => (s._id === action.payload._id ? action.payload : s)),
      };

    case types.DELETE_STORE_SUCCESS:
      return { ...state, loading: false, stores: state.stores.filter((s) => s._id !== action.payload) };

    case types.FETCH_STORES_FAILURE:
    case types.FETCH_STORE_STATS_FAILURE:
    case types.FETCH_STORE_GROUPS_FAILURE:
    case types.CREATE_STORE_GROUP_FAILURE:
    case types.CREATE_STORE_FAILURE:
    case types.UPDATE_STORE_FAILURE:
    case types.DELETE_STORE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default storeReducer;
